export const WAITING_PAGE_CLASS_NAMES = {
    page: 'bustly-waiting-page',
    panel: 'bustly-waiting-page__panel',
    title: 'bustly-waiting-page__title',
    message: 'bustly-waiting-page__message',
    button: 'bustly-waiting-page__button',
} as const;

export const WAITING_PAGE_STYLE_SHEET = `
[data-bustly-waiting-page].${WAITING_PAGE_CLASS_NAMES.page} {
  min-height: 100vh;
  width: 100%;
  display: grid;
  place-items: center;
  padding: 32px;
  background:
    radial-gradient(circle at 50% 42%, rgba(232, 231, 228, 0.38) 0%, rgba(255, 255, 255, 0) 34%),
    linear-gradient(180deg, #fcfcfb 0%, #f8f8f7 100%);
  box-sizing: border-box;
}

[data-bustly-waiting-page] *,
[data-bustly-waiting-page] *::before,
[data-bustly-waiting-page] *::after {
  box-sizing: border-box;
}

[data-bustly-waiting-page] .${WAITING_PAGE_CLASS_NAMES.panel} {
  width: min(360px, 100%);
  min-height: 96px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
  text-align: left;
}

[data-bustly-waiting-page] .${WAITING_PAGE_CLASS_NAMES.title},
[data-bustly-waiting-page] .${WAITING_PAGE_CLASS_NAMES.message} {
  margin: 0;
  letter-spacing: 0;
  background:
    linear-gradient(
      105deg,
      rgba(38, 36, 42, 0.34) 0%,
      #4f4d57 28%,
      #9b999f 52%,
      #4f4d57 76%,
      rgba(38, 36, 42, 0.34) 100%
    );
  background-size: 280% 100%;
  background-clip: text;
  color: transparent;
  animation: bustlyWaitingPageText 7.2s linear infinite;
  will-change: background-position;
}

[data-bustly-waiting-page] .${WAITING_PAGE_CLASS_NAMES.title} {
  font-size: 20px;
  line-height: 1.3;
  font-weight: 430;
}

[data-bustly-waiting-page] .${WAITING_PAGE_CLASS_NAMES.message} {
  font-size: 13px;
  line-height: 1.45;
  font-weight: 400;
}

[data-bustly-waiting-page] .${WAITING_PAGE_CLASS_NAMES.button} {
  min-width: 132px;
  height: 44px;
  margin-top: 12px;
  padding: 0 22px;
  border: 0;
  border-radius: 12px;
  color: #ffffff;
  background: #1a162f;
  font-size: 15px;
  font-weight: 650;
  cursor: pointer;
  transition:
    transform 160ms ease,
    background 160ms ease,
    box-shadow 160ms ease;
}

[data-bustly-waiting-page] .${WAITING_PAGE_CLASS_NAMES.button}:hover {
  transform: translateY(-1px);
  background: #2d2650;
  box-shadow: 0 12px 28px rgba(26, 22, 47, 0.18);
}

[data-bustly-waiting-page] .${WAITING_PAGE_CLASS_NAMES.button}:active {
  transform: translateY(0);
  box-shadow: none;
}

@keyframes bustlyWaitingPageText {
  0% {
    background-position: 140% 50%;
  }

  100% {
    background-position: -140% 50%;
  }
}

@media (prefers-reduced-motion: reduce) {
  [data-bustly-waiting-page] .${WAITING_PAGE_CLASS_NAMES.title},
  [data-bustly-waiting-page] .${WAITING_PAGE_CLASS_NAMES.message} {
    animation: none;
  }
}

@media (max-width: 640px) {
  [data-bustly-waiting-page].${WAITING_PAGE_CLASS_NAMES.page} {
    padding: 24px;
  }

  [data-bustly-waiting-page] .${WAITING_PAGE_CLASS_NAMES.panel} {
    width: min(320px, 100%);
    gap: 8px;
    min-height: 88px;
  }
}
`;
